import React from "react";
import { useEffect,useRef,useState } from "react";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import { Navigate, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import MbpAthnUi from "Utils/MbpAthn";
import MgpStore from "Stores/Store";
import MembIdntMthdChngApi from "Apis/MembIdntMthdChngApi";
import MbpAthnRsltVrfRqstApi from "Apis/MbpAthnRsltVrfRqstApi";
import ApiResultModal from "Components/ApiResultModal";
import MembMktgAgreInqApi from "Apis/MembMktgAgreInqApi";
import MembMktgAgreChngApi from "Apis/MembMktgAgreChngApi";
import { refererGetApi } from "Apis/refererApi";
import ApiError from "Utils/ApiError";
import UseLangLstQuery from "Apis/LangTxtInqApi";



const AppMembIdntMthdChngUi = () => {
    const {isLoading,error,data: langData}:any = UseLangLstQuery();
    const navigate = useNavigate();
    const idntMthdCd = useSelector((state: any) => state.IdntMthdCdState?.IdntMthdCd);
    const [resultModalOpen, setResultModalOpen] = useState(false);
    const [emlNtfyRecvYn,setEmlNtfyRecvYn] = useState("N");
    const [smsNtfyRecvYn,setSmsNtfyRecvYn] = useState("N");
    const [referrerUrl, setReferrerUrl] = useState("/");
    const emlNtfyRecvYnRef = useRef("N");
    const smsNtfyRecvYnRef = useRef("N");
    const AgreSmsNtfyFunc = (e: React.ChangeEvent<HTMLInputElement>) => {
        const nextYn = e.target.checked ? "Y" : "N";
        setSmsNtfyRecvYn(nextYn);
        smsNtfyRecvYnRef.current = nextYn;
    };
    const [resultModalMessage, setResultModalMessage] = useState("");
    const [modalAction, setModalAction] = useState<(() => void) | null>(null);

    const openResultModal = (message: string, onClose?: () => void) => {
        setResultModalMessage(message);
        setModalAction(() => onClose || null);
        setResultModalOpen(true);
    };

    const closeResultModal = () => {
        setResultModalOpen(false);
        const action = modalAction;
        setModalAction(null);
        if (action) action();
    };

    useEffect(() => {
        emlNtfyRecvYnRef.current = emlNtfyRecvYn;
    }, [emlNtfyRecvYn]);

    useEffect(() => {
        smsNtfyRecvYnRef.current = smsNtfyRecvYn;
    }, [smsNtfyRecvYn]);
    
    useEffect(()=>{
        refererGetApi()
        .then((resp) => {
            if(resp.apiHdr.code == "ATHN0000") {
                setReferrerUrl(resp.apiBody.redirectUri);
            }
            return;
        });
        function kmcRespFunc (kmcApiTknrslt:string,kmcApiCertNumrslt:string){
            MbpAthnRsltVrfRqstApi(kmcApiTknrslt,kmcApiCertNumrslt)
            .then((resp) => {
                if(resp.apiHdr.code == "ATHN0000") {
                    openResultModal("변경이 완료되었습니다.", () => navigate("/Connect/AppStrt"));
                    // MembMktgAgreChngApi(null,smsNtfyRecvYnRef.current)
                    // .then((Resp) => {
                    //     switch(Resp.apiHdr.code){
                    //         case "MEMB0000":
                    //             openResultModal("변경이 완료되었습니다.", () => navigate(referrerUrl));
                    //             //마케팅 수신 동의가 변경되었습니다.
                    //             break;
                    //         default:
                    //             ApiError(langData,Resp.apiHdr.code);
                    //             return;
                    //     }
                    // });
                }else{
                    openResultModal((langData&&langData.GLB_ATHN_FAIL_DESC_00) + resp.apiHdr.code);
                }
            });
            
        }
        window.kmcRespFunc = kmcRespFunc;
        MembMktgAgreInqApi()
        .then((resp) => {
            setEmlNtfyRecvYn(resp.apiBody.emlNtfyRecvYn);
            setSmsNtfyRecvYn(resp.apiBody.smsNtfyRecvYn);
            emlNtfyRecvYnRef.current = resp.apiBody.emlNtfyRecvYn;
            smsNtfyRecvYnRef.current = resp.apiBody.smsNtfyRecvYn;
        });
        },[])
    return(
        <>
        <ApiResultModal
            open={resultModalOpen}
            message={resultModalMessage}
            onClose={closeResultModal}
confirmText={langData&&langData.COMM_MAIN_CHK_MAIN_BTN_00}
        />
        <Helmet>
            <title>{`${process.env.REACT_APP_TITLE_PREFIX} ${langData&&langData.MYPAGE_MENU_ATHN_CHNG_BTN_00}`}</title>
        </Helmet>
        <div className="container1300 BgW pb200">
            <div className="myPageSubTitlWrap">
                <p className="myPageCtxtTitl">{langData&&langData.MYPAGE_MENU_ATHN_CHNG_BTN_00}</p>
            </div>
            <div className="myPageSubCtxtWrap container640">
            
                {/* email인증회원은 휴대폰인증으로 인증방식 변경이 가능합니다. */}
                <div className="idntMthdChngTxtWrap">
                    {/* <div className="idntMthdChngImgWrap">
                        <img src={process.env.PUBLIC_URL+'/images/MbpAthnIcon.png'} alt="" />
                    </div> */}
                    <div className='idntMthdChngTxt'>
                        <p>
                           	본인인증이 필요한 서비스 입니다.<br />
                            휴대폰 본인인증을 진행해주세요.
                        </p>
                    </div>
                </div>
                <MbpAthnUi athnPrpsCd={"MTHD_CHNG"} AthnTxt={langData&&langData.COMM_MAIN_ATHN_MAIN_BTN_00} smsNtfyRecvYnRef={smsNtfyRecvYnRef}/>
            </div> 
        </div>
        </>
    )
}

export default AppMembIdntMthdChngUi;